import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './locale/en';
import enUS from './locale/en-US';

Vue.use(VueI18n);

const messages = {
  en,
  'en-US': enUS,
};

const i18n = new VueI18n({
  locale: navigator.language,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages,
});

export default i18n;
